import { useEffect, useState } from "react";
import NotesContainer from "../Notes/NotesContainer";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  documentId,
} from "firebase/firestore";
import { db } from "../../firebase";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { roles } from "../../firebase.collection";

function TherapyNoteContainer(props) {
  const { currentUser } = useAuth();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setUserRole] = useState(null);

  const queryRole = () => {
    if (currentUser) {
      const userId = currentUser.uid;
      const q = query(roles, where(documentId(), "==", userId));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        if (!querySnapshot.empty) {
          const role = querySnapshot.docs[0].data().role;
          setUserRole(role);
          fetchNotes(role); // Exécute `fetchNotes` après avoir récupéré le rôle
        } else {
          console.log("❌ Aucun rôle trouvé.");
          setUserRole(null);
        }
      });

      return () => unsubscribe();
    }
  };

  useEffect(() => {
    if (currentUser) {
      return queryRole();
    }
    return undefined;
    // queryRole intentionally captures the current props/client query for this subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const fetchNotes = (role) => {
    if (!role) return; // Vérification ajoutée

    const notesRef = collection(db, "notes");
    let q;

    if (role === "Super Admin" || role === "Clinical Director") {
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        where("clientId", "==", props.clientId),
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else if (role === "Therapist") {
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        where("clientId", "==", props.clientId),
        //where("doneBy", "==", currentUser.displayName), // 🔴 Filtre par le thérapeute connecté
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else {
      console.log("⚠️ Rôle non autorisé pour voir les therapyNotes :", role);
      return;
    }

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setLoading(false);
      setNotes(notesData);
    });

    return () => unsubscribe();
  };

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <div style={{ paddingBottom: "15px" }}>
              <NotesContainer
                key={note.id}
                noteContent={note.noteContent}
                effectiveDate={note.effectiveDateTime}
                noteDate={formattedDate}
                noteTime={formattedTime}
                doneBy={note.doneBy}
                timeStamp={formattedTimestamp}
                lastModification={formattedLastModification}
                clientPic={note.clientProfilePicture}
                clientFirstName={note.clientFirstName}
                clientLastName={note.clientLastName}
                noteId={note.id}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default TherapyNoteContainer;
